import React from 'react';
import '../style.less';

interface CardContent {
  children: React.ReactNode,
  className?: string, 
  style?: React.CSSProperties
}

const clsPrefix = "c-item-card";
const ItemCardContent:React.FC<CardContent> = (props) => {
  return (
    <div className={`${clsPrefix}__content ${props.className}`} style={props.style}>
      {props.children}
    </div>
  )
}
export default ItemCardContent;